module.exports = __webpack_public_path__ + "files/02806e8bc3e7ccb45c317f09cb65a8d2.png";


//////////////////
// WEBPACK FOOTER
// ./images/icon50x50.png
// module id = 496
// module chunks = 76